var _defs, _rect, _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.1 50.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.1px;opacity:0;}.cls-2{fill:#fff;}.cls-3{fill:#34b9ae;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.05,
    y: 0.05,
    width: 50,
    height: 50
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 25,
    cy: 25,
    r: 22.5,
    transform: "translate(-7.5 11.25) rotate(-22.03)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25,6A19,19,0,1,0,44,25,19,19,0,0,0,25,6Z",
    transform: "translate(0.05 0.05)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20,13.06c.17,1.23,1.08,13,1.4,15.28s1.84,2.59,3.57,2.59,3.24-.35,3.57-2.59,1.23-14,1.4-15.28C30,11.57,31,10,25,10S20,11.57,20,13.06Z",
    transform: "translate(0.05 0.05)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.64,36.46a3.52,3.52,0,1,1-3.52-3.54A3.53,3.53,0,0,1,28.64,36.46Z",
    transform: "translate(0.05 0.05)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconNotice);
export default __webpack_public_path__ + "static/media/cloud_icon_notice.30c15248baa7405372c741c3396b4349.svg";
export { ForwardRef as ReactComponent };